import React from "react";
import "../Style/comment.css";
export default function CommentStar({data}){
    const widthPercent = (+data.totalRate * 100) / 5;
    return <div className="flex flexCol rel commentStarMainDiv">
        <div className="flex commentStarBg" style={{width:widthPercent+"%"}}></div>
        <img src="/image/star.webp" alt="comment star" className="commentStarImg" width={100} draggable="false"/>
    </div>
}